import { TopicModel } from "@/models/TopicModel";
import { CategoryModel } from "@/models/CategoryModel";
import { ServerHelper } from "@/api/ServerHelper";
import { VariantFilter } from "@/models/VariantFilter";
import { Route } from "vue-router";
import { Api } from "@/api/Api";

export class Tracker {
  declare window: { dataLayer: any };
  static win = window;
  
  public async trackSearchHitClick(
    keyword: string,
    hitCount: number,
    topic: TopicModel,
    basePath: string,
    lang: string
  ) {
    // this.gaTrackSearchEvent("keyword hit", keyword)
    //
    const trackUrl = `${ServerHelper.getBaseUrl()}/search`;
    await Api.trackSearch(keyword, hitCount, trackUrl, lang, this.getOrCreateSessionId());
  }

  public async trackAddToPrint(
    topic: TopicModel,
    basePath: string,
    lang: string,
    category: CategoryModel | undefined,
    subCategory: CategoryModel | undefined
  ) {
    // this.gaTrackPrintBasketEvent(`add item`, window.location.href)
    //
    const trackUrl = this.createTrackingUrl(topic, basePath, lang);
    await Api.trackAddedToBasket(topic.title, trackUrl, lang, category, subCategory, this.getOrCreateSessionId());
  }

  public async trackPageView(title: string) {
    // if (title !== gaPrevTrackedPageTitle) { // typeof window.ga === "function" &&
    //   // window.ga("set", "page", window.location.pathname)
    //   // window.ga("send", "pageview")
    //   const gaTitle = title ? title : "Start"
    //   this.gaEvent(`Page`, "open", gaTitle, window.pathWithFilter || 1)
    //   gaPrevTrackedPageTitle = title
    // }
  }

  public async trackPage(
    topic: TopicModel,
    basePath: string,
    lang: string,
    duration: number,
    progress: number,
    referrer: string,
    category: CategoryModel,
    subCategory: CategoryModel
  ) {
    // this.gaTrackPage(topic.title)
    //
    const trackUrl = this.createTrackingUrl(topic, basePath, lang);
    await Api.trackPageView(topic, trackUrl, lang, duration, progress, referrer, category, subCategory, this.getOrCreateSessionId());
  }

  /***
   * Strip any unwanted url sections and only keep information that indicates the uniqueness for specific topic url
   */
  createTrackingUrl(topic: TopicModel, basePath: string, lang: string): string {
    let trackUrl = `${ServerHelper.getBaseUrl()}${basePath}/${topic.id}`;

    // Remove language section
    trackUrl = trackUrl.replace(`/${lang.toLowerCase()}/`, "/");

    // Remove "cat" section
    trackUrl = trackUrl.replace(`/cat/`, "/");

    return trackUrl;
  }

  // /**
  //  * Google Analytics Event registration
  //  * @param category, ex: "Video"
  //  * @param action, ex: "play"
  //  * @param label, ex: "Fall Campaign"
  //  * @param value, ex: 42
  //  */
  // private gaEvent(category = "", action = "", label = "", value = "") {
  //   if (window.dataLayer) {
  //     window.dataLayer.push({
  //       "event": category,
  //       "event_action": action,
  //       // "event_category": category,
  //       "event_label": label,
  //       "value": value
  //     })
  //   }
  // }
  //

  trackSearchEvent(action = "open", keyword = "") {
    // this.gaEvent(`Search`, action, keyword, 1)
  }

  trackArticleFeedback(action = "positive", url = "") {
    // this.gaEvent(`Topic Feedback`, action, url, 1)
  }

  trackPrintBasketEvent(action = "", keyword = "") {
    // this.gaEvent(`Document Basket`, action, keyword, 1)
  }

  trackVideoPlayEvent(video: string) {
    // this.gaEvent(`Video`, "play", video, 1)
  }

  setGAPageUrl(filters: VariantFilter<string | string[]>[], $route: Route) {
    const queryVarName = "variant";
    const win = window as any;
    win.dataLayer = win.dataLayer || [];

    const query = `${queryVarName}={${filters.map((f) => f.entry).join(",")}}`;
    const hash = $route.hash;

    const pagePath = `${$route.path}${query}${hash}`;

    // if (typeof window.ga === "function") {
    //   var trackers = window.ga.getAll();
    //   var firstTracker = trackers[0];
    //   var trackerName = firstTracker.a.data.values[":name"];
    //   window.ga(`${trackerName}.set`, "page", pagePath);
    // }
    win.pathWithFilter = `${pagePath}`;
    // window.dataLayer.push({ gtm: { newUrl: `${pagePath}` } });
    // window.dataLayer.push({ gtm: { newUrlWithFilters: `${pagePath}` } });
    // window.dataLayer.push({ page: `${pagePath}` });
  }

  getOrCreateSessionId() {
    const sessionKey = 'tracking_session_id';
    let id = sessionStorage.getItem(sessionKey);
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem(sessionKey, id);
    }
    return id;
  }
}
